export default "__VITE_ASSET__BpYuZpmB__"